import {StagingTitelineAppSafetyData} from "../types/StagingTitelineAppSafetyData";
import {SafetyData} from "../types/SafetyData";
import { getApiUrl } from '../config/api';

export const fetchSafetyDataByPid = async (pid?: number, aid: number = -1): Promise<SafetyData[]>  => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineSafetyData/GetSafetyDataByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No safety data found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching safety data for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppSafetyData[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((safety) => safety.DataSource === aid.toString());
        }

        return backendData.map((safety) => ({
            key: safety.Sid,
            sid: safety.Sid,
            pid: safety.Pid,
            jha: safety.JHA,
            sbo: safety.SBO,
            hazards: safety.Hazards,
            swms_reviews: safety.SWMSReviews,
            observations: safety.Observations,
            operations_incidents: safety.OperationsIncidents,
            incidents: safety.Incidents,
            reportable_incidents: safety.ReportableIncidents,
            lost_time_injuries: safety.LostTimeInjuries,
            medical_treated_injuries: safety.MedicalTreatedInjuries,
            site_inspections: safety.SiteInspections,
            comments: safety.Comments,
        }));

    } catch (error) {
        console.error("Error in fetchSafetyDataByPid API call:", error);
        return [];
    }
};

export const addSafetyDataRow = async (safetyDataRow: SafetyData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineSafetyData/AddSafetyData');

    const cloudPayload = [
        {
            Pid: safetyDataRow.pid,
            JHA: safetyDataRow.jha,
            SBO: safetyDataRow.sbo,
            Hazards: safetyDataRow.hazards,
            SWMSReviews: safetyDataRow.swms_reviews,
            Observations: safetyDataRow.observations,
            OperationsIncidents: safetyDataRow.operations_incidents,
            Incidents: safetyDataRow.incidents,
            ReportableIncidents: safetyDataRow.reportable_incidents,
            LostTimeInjuries: safetyDataRow.lost_time_injuries,
            MedicalTreatedInjuries: safetyDataRow.medical_treated_injuries,
            SiteInspections: safetyDataRow.site_inspections,
            Comments: safetyDataRow.comments,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Safety data row added to cloud successfully.");
            return true;
        } else {
            console.error("Failed to add safety data row to cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in addSafetyDataRow API call:", error);
        return false;
    }
};

export const updateSafetyDataRow = async (sid: number, updatedRow: SafetyData) => {
    const apiUrl = getApiUrl(`/api/TitelineSafetyData/UpdateSafetyDataBySid/${sid}`);

    const cloudPayload = {
        JHA: updatedRow.jha,
        SBO: updatedRow.sbo,
        Hazards: updatedRow.hazards,
        SWMSReviews: updatedRow.swms_reviews,
        Observations: updatedRow.observations,
        OperationsIncidents: updatedRow.operations_incidents,
        Incidents: updatedRow.incidents,
        ReportableIncidents: updatedRow.reportable_incidents,
        LostTimeInjuries: updatedRow.lost_time_injuries,
        MedicalTreatedInjuries: updatedRow.medical_treated_injuries,
        SiteInspections: updatedRow.site_inspections,
        Comments: updatedRow.comments,
    };

    console.log("cloudPayload:", cloudPayload);

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Safety data row with Sid ${sid} updated successfully.`);
            return true;
        } else {
            console.error("Failed to update safety data row with Sid:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in updateSafetyDataRow API call:", error);
        return false;
    }
};

export const deleteSafetyDataBySid = async (sid: number) => {
    const apiUrl = getApiUrl(`/api/TitelineSafetyData/DeleteSafetyDataBySid/${sid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteSafetyDataBySid API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete safety data row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteSafetyDataBySid API call:", error);
        return false;
    }
};